import Log from '@lib/Log'
import Analytics from '@lib/Analytics'
import { LeadData } from './ApiClient.types'

type Cache = Record<string, string>

export class LeadCache {
  public static readonly responseCache: Record<string, Cache> = {}

  public static getLeadCache(req: LeadData): Cache | null {
    const key = LeadCache.getKey(req)
    const cache = this.responseCache[key]

    if (cache) {
      Log.info(this, 'lead already submitted: ' + cache.lid)
      Analytics.setLeadId(cache.lid)
    }

    return cache || null
  }

  public static saveLeadCache(req: LeadData, res: Cache) {
    const key = LeadCache.getKey(req)

    this.responseCache[key] = res
  }

  private static getKey(req: LeadData): string {
    const indType = req.industry_type
    const prodType = req.product_type

    return `${indType}-${prodType}`
  }
}
